import { Download } from "@reverb-ui/icons-react";
import { Button, Spinner, Text } from "@reverb-ui/react";
import { ReportsFilesContext } from "presentation/containers/context-api/ReportsFilesProvider";
import { useContext } from "react";

interface IDownloadPdfButtonProps {}

export const DownloadPdfButton: React.FC<IDownloadPdfButtonProps> = () => {
  const { downloadPdfReport, downloadingReports } =
    useContext(ReportsFilesContext);

  return (
    <Button
      leftIcon={
        downloadingReports ? (
          <Spinner color="white" size="sm" />
        ) : (
          <Download color="white" />
        )
      }
      colorScheme="blue"
      borderRadius="md"
      px="4"
      py="2"
      _hover={{ bg: "blue.600" }}
      _active={{ bg: "blue.700" }}
      _focus={{ bg: "blue.500" }}
      _disabled={{ opacity: 0.4 }}
      type="button"
      disabled={downloadingReports}
      onClick={downloadPdfReport}
    >
      <Text fontSize="md" color="white">
        Download PDF
      </Text>
    </Button>
  );
};

export default DownloadPdfButton;
